
const React = require('react')

const products = [
    {
        "title": "mill choclkate",
        "style": "bar",
        "sku": "11"
    },
    {
        "title": "dark choclkate",
        "style": "bar",
        "sku": "12"
    },
    {
        "title": "galaxy choclkate",
        "style": "bar",
        "sku": "13"
    }
]


let dataProfile = {
    spaceKey: "10000297@4@F@10@10@20251124@7@Y@SVR"
}

const withCustomerStoredcardsHOC = C => {
    //Step 1 C  define inline
    class WithCustomerStoredcardsHOC extends React.Component {
      constructor(props){

        super(props)
        let me = this
        this.getAppDetails = this.getAppDetails.bind(me)
    }

      state = {
        searchTerm: ""
      };
     
  
      getAppDetails(paramQSpaceId){
        console.log('order detail confirmationcode**************', paramQSpaceId)
       // this.props.loadOrderderNow(paramQSpaceId)
        // this.props.getSoDetails("mancreek")
 
       // this.props.ordAndImagesSV()
        
     }
     componentWillMount()	{
        console.log('!!!!!!!!sv--task=--- link sends us params')
        let id;
        if(this.props.svparams){
           id = this.props.svparams.id
        
        }else{
         console.log('not called by router we might be creat')
         id = -11;
        }
       
   console.log('!!!!!!!!!!!!!!!!sbv--HOC  C gets customerId  ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:'+ id)
   
   
      this.getAppDetails(id)
     }

      render() {
       
        let id;
        let svcustProfile = {
          customerId: -11
      }

      let svparams ={
        id: -12
      }
        if(this.props.svparams){
          console.log('MON23 called by router we might be creat', this.props.svparams)
          svcustProfile.customerId = this.props.svparams.id
          svparams.id = this.props.svparams.id
        
        }else{
         console.log('MONE23 not called by router we might be creat')
         svcustProfile.customerId = -11;
         svparams.id = -13
        }
        
       

       console.log('sv%%%svcustProfile withCustomerStoredcardsHOC', svcustProfile)
        
        return (
          <div>
           
            <C svcustProfile={svcustProfile} dataProfile={dataProfile} svparams={svparams}  />
          </div>
        );
      }
    };
    //Step 2 retuen C
    WithCustomerStoredcardsHOC.displayName = `WithCustomerStoredcardsHOC(${getDisplayName(C)})`;
    return WithCustomerStoredcardsHOC;
  };
  
  const getDisplayName = (C) => {
    return C.displayName || C.name || 'Component';
  }


 


  export default withCustomerStoredcardsHOC